import { Card, CardContent } from '../ui/card';
import { Users, FileJson, Activity, Calendar } from 'lucide-react';

export function UsageStats({ stats }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="usage-stats">
      <Card>
        <CardContent className="pt-4 pb-3">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-muted-foreground">Total Users</p>
              <p className="text-2xl font-bold">{stats.total_users}</p>
            </div>
            <Users className="w-8 h-8 text-primary/20" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-4 pb-3">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-muted-foreground">Total Automata</p>
              <p className="text-2xl font-bold">{stats.total_automata}</p>
            </div>
            <FileJson className="w-8 h-8 text-primary/20" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-4 pb-3">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-muted-foreground">Active (7d)</p>
              <p className="text-2xl font-bold">{stats.active_7d}</p>
            </div>
            <Activity className="w-8 h-8 text-green-500/20" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-4 pb-3">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-muted-foreground">Active (30d)</p>
              <p className="text-2xl font-bold">{stats.active_30d}</p>
            </div>
            <Calendar className="w-8 h-8 text-blue-500/20" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
